import React from "react";

export default function DeviceTypeSummaryCard({
  title,
  badge,
  badgeClass,
  total,
  online,
  offline,
  alert,
  disabled,
}) {
  return (
    <div className="rounded-[26px] border border-white/70 bg-white/92 p-5 shadow-[0_16px_40px_rgba(15,23,42,0.06)] dark:border-white/10 dark:bg-[#111827]/82">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-lg font-bold text-gray-900 dark:text-white">
            {title}
          </div>
          <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            현재 상태 요약
          </div>
        </div>

        <span
          className={`inline-flex whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${badgeClass}`}
        >
          {badge}
        </span>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 xl:grid-cols-5">
        <div className="rounded-2xl bg-gray-50 px-4 py-3 dark:bg-[#0F172A]">
          <div className="text-xs text-gray-500 dark:text-gray-400">전체</div>
          <div className="mt-1 text-xl font-bold text-gray-900 dark:text-white">
            {total}
          </div>
        </div>

        <div className="rounded-2xl bg-emerald-50 px-4 py-3 dark:bg-emerald-500/10">
          <div className="text-xs text-emerald-700 dark:text-emerald-300">
            온라인
          </div>
          <div className="mt-1 text-xl font-bold text-emerald-700 dark:text-emerald-300">
            {online}
          </div>
        </div>

        <div className="rounded-2xl bg-gray-100 px-4 py-3 dark:bg-white/5">
          <div className="text-xs text-gray-600 dark:text-gray-400">
            오프라인
          </div>
          <div className="mt-1 text-xl font-bold text-gray-800 dark:text-white">
            {offline}
          </div>
        </div>

        <div className="rounded-2xl bg-red-50 px-4 py-3 dark:bg-red-500/10">
          <div className="text-xs text-red-700 dark:text-red-300">위험</div>
          <div className="mt-1 text-xl font-bold text-red-700 dark:text-red-300">
            {alert}
          </div>
        </div>

        <div className="rounded-2xl bg-slate-100 px-4 py-3 dark:bg-slate-500/10">
          <div className="text-xs text-slate-700 dark:text-slate-300">
            비활성
          </div>
          <div className="mt-1 text-xl font-bold text-slate-700 dark:text-slate-300">
            {disabled}
          </div>
        </div>
      </div>
    </div>
  );
}